module.exports = __webpack_public_path__ + "img/camp.25629eda.svg";